import React from 'react';
import './BrandMark.css';

const BrandMark = ({ className = '' }) => (
  <span className={`brand-mark ${className}`.trim()} role="img" aria-label="SDI Tecnologia">
    <img src="/logo-sdi.png" alt="" aria-hidden="true" />
  </span>
);

export default BrandMark;
